import jsCookie from "js-cookie";

export const getClientCookie = (cookieName) => {
  try {
    return JSON.parse(jsCookie.get(cookieName));
  } catch (_) {
    return jsCookie.get(cookieName);
  }
};

export const setCookie = (name, value, expiry = 365, secure = false) => {
  jsCookie.set(name, value, { expires: expiry, path: "/", secure });
};

export const setLoginCookies = (token, user) => {
  setCookie("webapp_token", JSON.stringify(token));
  setCookie("user_phone", JSON.stringify(user.phone || ""));
  setCookie("user_name", JSON.stringify(user.name || ""));
  setCookie("user_email", JSON.stringify(user.email || ""));
  setCookie(
    "user_chosen_user_type",
    JSON.stringify(user.chosen_user_type || "")
  );
  setCookie("user_about", JSON.stringify(user.about || ""));
  setCookie("user_id", JSON.stringify(user.user_id || ""));
  setCookie("user_img", JSON.stringify(user.img || ""));
  setCookie("user_iam_verified", JSON.stringify(user.iam_verified || ""));
  setCookie("user_rega_approved", JSON.stringify(user.rega_approved || ""));
  setCookie("user_listings", JSON.stringify(user.listings || ""));
  setCookie("user_favs", JSON.stringify(user.favs));
  setCookie("user_type", JSON.stringify(user.type));
  setCookie("user_paid", JSON.stringify(user.paid));
  setCookie("user_create_time", JSON.stringify(user.create_time));
  setCookie(
    "user_active_aqar_plus_user",
    JSON.stringify(user.active_aqar_plus_user)
  );
  setCookie("user_show_aqar_plus", JSON.stringify(user.show_aqar_plus));
};
